/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const KeynoteForMac32 = (props: SVGProps) => (
    <AccessibleSVG width={32} height={32} viewBox="0 0 32 32" {...props}>
        <mask
            id="prefix__a"
            style={{
                maskType: 'alpha',
            }}
            maskUnits="userSpaceOnUse"
            x={0}
            y={0}
            width={32}
            height={32}
        >
            <path
                d="M32 10.01c0-.382 0-.764-.002-1.147a45.72 45.72 0 00-.015-.965c-.018-.701-.06-1.408-.184-2.102a7.094 7.094 0 00-.659-1.998A6.722 6.722 0 0028.202.86 7.092 7.092 0 0026.204.2c-.693-.124-1.4-.166-2.102-.184a46.263 46.263 0 00-.965-.015C22.754 0 22.372 0 21.99 0H10.01c-.382 0-.764 0-1.147.002-.322.002-.643.006-.965.015-.702.018-1.409.06-2.103.184A7.092 7.092 0 003.798.86 6.719 6.719 0 00.86 3.798 7.092 7.092 0 00.2 5.796c-.124.694-.166 1.4-.184 2.102-.01.322-.013.643-.015.965C0 9.246 0 9.628 0 10.01v11.98c0 .382 0 .764.002 1.147.002.322.006.643.015.965.018.701.06 1.409.184 2.102.127.704.333 1.359.659 1.998a6.72 6.72 0 002.938 2.938c.639.326 1.294.532 1.997.659.694.124 1.401.166 2.103.184.322.01.643.013.965.015.383.002.765.002 1.147.002h11.98c.382 0 .764 0 1.147-.002.322-.002.643-.006.965-.015.702-.018 1.409-.06 2.102-.184a7.093 7.093 0 001.998-.659 6.719 6.719 0 002.938-2.938c.326-.64.532-1.294.659-1.998.124-.694.166-1.4.184-2.102.01-.322.013-.643.015-.965.002-.383.002-.765.002-1.147V10.01z"
                fill="#fff"
            />
        </mask>
        <g mask="url(#prefix__a)">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M32 10.01c0-.382 0-.764-.003-1.147a45.72 45.72 0 00-.014-.965c-.019-.701-.06-1.408-.185-2.102a7.09 7.09 0 00-.658-1.998A6.722 6.722 0 0028.202.86a7.092 7.092 0 00-1.998-.658c-.693-.125-1.4-.166-2.102-.185a46.274 46.274 0 00-.966-.015C22.754 0 22.372 0 21.99 0H10.01c-.382 0-.764 0-1.147.002-.322.002-.643.006-.965.015-.702.019-1.41.06-2.103.185A7.092 7.092 0 003.798.86 6.719 6.719 0 00.86 3.798 7.093 7.093 0 00.2 5.796c-.124.694-.166 1.4-.184 2.102-.01.322-.013.643-.015.965C0 9.246 0 9.628 0 10.01v11.98c0 .382 0 .764.002 1.146.002.322.006.644.015.966.018.701.06 1.408.184 2.101.127.704.333 1.36.659 2a6.717 6.717 0 002.938 2.937c.639.325 1.294.532 1.997.658.694.125 1.401.166 2.103.185.322.009.643.013.965.015.383.002.765.002 1.147.002h11.98c.382 0 .764 0 1.146-.002.322-.002.644-.006.966-.015.701-.019 1.409-.06 2.102-.185a7.087 7.087 0 001.998-.658 6.719 6.719 0 002.938-2.938 7.09 7.09 0 00.658-1.999c.125-.693.166-1.4.185-2.101.009-.322.013-.644.014-.966.003-.382.003-.764.003-1.146V10.01z"
            />
            <path d="M32 0H0v32h32V0z" fill="url(#prefix__paint0_linear_56_34)" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M25.451 13.01l-1.2-7.467a1.2 1.2 0 00-1.184-1.01H8.933a1.2 1.2 0 00-1.184 1.01l-1.2 7.467a1.2 1.2 0 001.184 1.39h16.534a1.2 1.2 0 001.184-1.39zM20.267 26.133h-3.6v-10.8h-1.334v10.8h-3.6c-.533 0-.8.267-.8.667s.267.667.8.667h8.534c.533 0 .8-.267.8-.667s-.267-.667-.8-.667z"
                fill="#fff"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16 8.267l-1.803 2.157a3.37 3.37 0 001.803.51 3.37 3.37 0 001.803-.51 2.728 2.728 0 001.114-1.333L16 8.267z"
                fill="#66C155"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13.083 9.091a2.35 2.35 0 010-1.649L16 8.267l-2.917.824z"
                fill="#FA9E27"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.197 6.11A3.37 3.37 0 0116 5.6v2.667l-1.803-2.158z"
                fill="#AB4287"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18.918 7.442a2.727 2.727 0 00-1.115-1.333A3.37 3.37 0 0016 5.6v2.667l2.918.824a2.35 2.35 0 000-1.649z"
                fill="#61D9FE"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.197 10.424a2.727 2.727 0 01-1.114-1.333L16 8.267l-1.803 2.157z"
                fill="#FBCE5A"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13.083 7.442a2.727 2.727 0 011.114-1.333L16 8.267l-2.917-.825z"
                fill="#E85A5E"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M22.56 12H9.44c-.427 0-.64.213-.64.533 0 .32.213.534.64.534h13.12c.427 0 .64-.214.64-.534 0-.32-.213-.533-.64-.533z"
                fill="#C7E8FD"
            />
        </g>
        <defs>
            <linearGradient
                id="prefix__paint0_linear_56_34"
                x1={16}
                y1={31.36}
                x2={16}
                y2={1.05}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#1A66EF" />
                <stop offset={1} stopColor="#24CCFD" />
            </linearGradient>
        </defs>
    </AccessibleSVG>
);

export default KeynoteForMac32;
